// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable guard-for-in */
import EventHandler from '../../utils/dom/event-handler';
import { Events } from '../../utils/dom/html-events';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';
import FormGenerator, { FormTypes } from '../../components/FormGenerator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Manipulator from '../../utils/dom/manipulator';
import Modal from '../../components/Modal';

const CLICK_EVENT = 'click';

const SELECTOR_WRAPPER = '.p-edit-activity-and-interests-form';
const SELECTOR_FORM_WRAPPER = '.p-edit-activity-and-interests-form__container';
const SELECTOR_FORM = '.p-edit-activity-and-interests-form__form';
const SELECTOR_FORM_BUTTON = '.p-edit-activity-and-interests-form__submit-btn';
const SELECTOR_FORM_ERROR_CONTAINER = '.p-edit-activity-and-interests-form__error-container';
const SELECTOR_FORM_CLOSE_ERROR = '.js-dismiss-error';
const SELECTOR_FORM_EXIT_MODAL = '#activity-interests-exit-modal';
const SELECTOR_FORM_CLOSE_EXIT_MODAL = '.p-edit-activity-and-interests-form__exit-modal-btn';
const SELECTOR_FORM_CONFIRM_MODAL = '#activity-interests-confirm-modal';
const SELECTOR_FORM_CONFIRM_MODAL_STAY = '.p-edit-activity-and-interests-form__confirm-modal-stay';
const SELECTOR_FORM_CONFIRM_MODAL_SUBMIT = '.p-edit-activity-and-interests-form__confirm-modal-submit';
const SELECTOR_FORM_BACK_BTN = '.p-account-details-landing-page__back-btn-popup';


const IS_LOCAL = false;
const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';

class EditActivityAndInterests {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.formWrapper = SelectorEngine.findOne(SELECTOR_FORM_WRAPPER, this._wrapper);
		this.form = SelectorEngine.findOne(SELECTOR_FORM, this.formWrapper);
		this.stepsApi = Manipulator.getDataAttribute(this.form, 'steps-api');
		this.submitApi = Manipulator.getDataAttribute(this.form, 'submit-api');
		this.redirectUrl = Manipulator.getDataAttribute(this.form, 'redirect-url');
		this.formButton = SelectorEngine.findOne('.p-edit-activity-and-interests-form__submit-btn', this._wrapper);
		this._errorContainer = SelectorEngine.findOne(SELECTOR_FORM_ERROR_CONTAINER, this.formWrapper);
		this._closeErrorSnackBar = SelectorEngine.findOne(SELECTOR_FORM_CLOSE_ERROR, this._errorContainer);
		this._exitModal = new Modal(SelectorEngine.findOne(SELECTOR_FORM_EXIT_MODAL, this.container));
		const backBtn = SelectorEngine.find(SELECTOR_FORM_BACK_BTN, this.container);
		const closeExitModal = SelectorEngine.findOne(SELECTOR_FORM_CLOSE_EXIT_MODAL, this.container);
		this._confirmModal = new Modal(SelectorEngine.findOne(SELECTOR_FORM_CONFIRM_MODAL, this.container));
		this._confirmModalStay = SelectorEngine.findOne(SELECTOR_FORM_CONFIRM_MODAL_STAY, this.container);
		this._confirmModalSubmit = SelectorEngine.findOne(SELECTOR_FORM_CONFIRM_MODAL_SUBMIT, this.container);

		backBtn.forEach(btn => {
			btn.addEventListener('click', () => {
				this._exitModal.show();
			});
		});

		closeExitModal.addEventListener('click', () => {
			this._exitModal.hide();
		});

		this._confirmModalStay.addEventListener('click', () => {
			this._confirmModal.hide();
		});

		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});

		this.getFormDetails();
	}

	async getFormDetails() {
		try {
			const url = this.stepsApi;
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				// eslint-disable-next-line no-console
				console.log('Error :', error);
			}
		}
	}

	initiateFormGenerator(stepsData) {
		this.formGenerator = new FormGenerator(this.form, {
			questions: stepsData,
			totalSteps: 1,
			hasSeparator: false,
			themeColor: 'color-lta-blue',
			formType: FormTypes.SectionForm,
			isHideProgress: true,
			isBackButtonEnabled: false,
			isRenderDependentQuestion: false
		});

		this.formGenerator.onChange((answers) => {
			this.prepareRequestObject(answers);
		});

		// Here we have to check if any of the below checkbox value was changed from checked to unchecked. If so we have to show popup to the user, 
		// becasue of this we are storing the intial values.
		const checkList = ['ltaAdvantage', 'coach', 'official', 'volunteer', 'teacher', 'activator', 'competingPlayer'];
		const checkboxes = [...document.querySelectorAll('.lta-form-check-input')].filter(cb => checkList.includes(cb.value));
		const initialState = {};
		checkboxes.forEach(cb => {
			initialState[cb.value] = cb.checked;
		});

		EventHandler.on(this.formButton, CLICK_EVENT, () => {
			const isFormValid = this.formGenerator.formValidation();
			console.log(this.answerList);
			if (isFormValid) {
				// when the user clicks on submit we are pasing the initial value and final value.
				this.checkRole(initialState, this.answerList);
			}
		});

		this._confirmModalSubmit.addEventListener('click', () => {
			this.submitSupportForm(this.answerList);
			this._confirmModal.hide();
		});
	}

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT]?.map((item) => item.value),
				this.answerList = {
					...this.answerList,
					...formatObject
				};
			}
		}
	}
	
	checkRole(intialData, finalData) {
		// Here we check if any of the values were changes from checked to unchecked.
		const initial = intialData;
		const final = finalData;
		let unchecked = [];
	
		for (let key in initial) {
			const wasChecked = initial[key] === true;
			const isChecked = Array.isArray(final[key]) && final[key].includes("Yes");
	
			if (wasChecked && !isChecked) {
				unchecked.push(key);
			}
		}

		if (unchecked.length > 0) {
			// if any of the value were checked to unchecked we will show a popup.
			this._confirmModal.show();
		} else {
			this.submitSupportForm(finalData);
		}	
	}

	async submitSupportForm(answers) {
		startLoadingAnimation(true);

		const payload = Object.fromEntries(
			Object.entries(answers).map(([key, value]) => [key, value.join(", ")])
		);  

		const url = this.submitApi;
		const responseData = await Request.post(url, payload, {
			local: IS_LOCAL,
			req: {
				apiMode: ApiMode.LtaError
			}
		});
		const { Success, response } = responseData;
		if (Success) {
			window.location.href = this.redirectUrl;
		} else {
			this.formGenerator.enableSubmitButton();
			this._errorContainer.classList.remove('u-hidden');
			this._errorContainer.scrollIntoView();
		}
		stopLoadingAnimation(true);	
	}
}

const globalEditActivityAndInterests = new EditActivityAndInterests();
export default globalEditActivityAndInterests;
